import microuniversoApi from "app/api/microuniversoApi"
import { atualizarItemAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import globalMU from "globalMU"

declare const window:any

export type EditarAmbienteItemParams = {
    identificadorItens: number[],
    nome: string
}

export async function editarAmbiente(params: EditarAmbienteItemParams) {
    try {
        globalMU.blockUI()

        const orcamentoAtualizado = await microuniversoApi.Orcamento.editarAmbienteItem(
            params.identificadorItens,
            store.getState().orcamento.IdentificadorOrcamento,
            params.nome
        )
    
        window.orcamentoController.model.atualizar(orcamentoAtualizado)
        
    } finally {
        globalMU.unblockUI()
    }
}